module.exports = __webpack_public_path__ + "static/media/work_bg.3d701723.svg";